import React, { useContext } from 'react'
import useSiteList from '../utils/useSiteList'

const Context = React.createContext({})

/**
 * All Gatsby links (via <AElement>) under this will be checked. If it leads to
 * non-existent pages, an error will be thrown.
 *
 * @example
 *    <LinkCheckerProvider>
 *      <AElement href='/non-existent-page/'>hmm</Link>
 *    </LinkCheckerProvider>
 */

const LinkCheckerProvider = ({ children }) => {
  // Get a list of all site paths, and store it in a Context.
  // useLinkChecker() will pick this up later. This is an optimization
  // to reduce the number of GraphQL queries involved.
  const allSitePaths = useSiteList()
  const contextValue = { allSitePaths }
  return <Context.Provider value={contextValue}>{children}</Context.Provider>
}

const useLinkChecker = path => {
  const value = useContext(Context)
  if (!value) return

  // This won't exist without the context
  const { allSitePaths } = value
  if (!allSitePaths) return

  // Don't process external links, or anchors
  if (path.includes('://')) return
  if (path.startsWith('#')) return
  if (path === '/') return

  // Strip any anchors
  path = path.replace(/#.*$/, '')

  if (!allSitePaths.includes(path)) {
    throw new Error(`Link '${path}' leads to a non-existent page.`)
  }
}

export { LinkCheckerProvider, useLinkChecker }
